import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'

function Popout({
  content,
  children,
  tooltipInnerStyles = {},
  placement = 'top',
  visible = false,
}) {
  return (
    <Tooltip
      visible={visible}
      placement={placement}
      showArrow={false}
      overlay={<span>{content}</span>}
      overlayStyle={{ opacity: 1, padding: 0 }}
      overlayInnerStyle={{
        padding: '3px 6px',
        minHeight: '22px',
        backgroundColor: '#FFF',
        color: 'rgba(85, 91, 98, 1)',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        border: '0.5px solid #DFE3E8',
        borderRadius: '4px',
        boxShadow:
          '0px 4px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.08)',
        lineHeight: '16px',
        marginBottom: '1px',
        ...tooltipInnerStyles, //override the main tooltip area
      }}
    >
      {children}
    </Tooltip>
  )
}
export default Popout
